import { createOpenAIClient } from '~/utils/openaiClient';

const PACKAGE_DISPLAY_NAME_MODEL = 'gpt-4.1-mini';

export function normalisePackageDisplayNameResponse(content: string) {
  const displayName = content
    .trim()
    .replace(/^["'`]|["'`]$/g, '')
    .trim()
    .replace(/^(display name|package name)\s*:\s*/i, '')
    .trim()
    .replace(/^["'`]|["'`]$/g, '')
    .trim();

  return displayName || undefined;
}

export async function cleanPackageDisplayNameWithAi({
  currentDisplayName,
  originalPackageName,
  roomName,
}: {
  currentDisplayName: string;
  originalPackageName: string;
  roomName?: string;
}) {
  const client = createOpenAIClient();
  const roomInstruction = roomName
    ? `Use this room name exactly as the base room name: ${roomName}`
    : 'Remove package duration, occupancy codes, and trailing deal-option codes from the base room name.';
  const response = await client.responses.create({
    model: PACKAGE_DISPLAY_NAME_MODEL,
    input: [
      {
        role: 'system',
        content: 'Clean accommodation package display names for an admin form. Return only the cleaned display name.',
      },
      {
        role: 'user',
        content: [
          roomInstruction,
          'Strip package duration prefixes, occupancy codes, and trailing deal-option codes.',
          'Preserve meaningful inclusions after the room name, in title case.',
          'Example: "8N Deluxe Mountain & Ocean View Room 2A - with return airport transfers" -> "Deluxe Mountain & Ocean View Room - With Return Airport Transfers"',
          `Original package name: ${originalPackageName}`,
          `Current display name: ${currentDisplayName}`,
        ].join('\n'),
      },
    ],
    text: {
      format: {
        type: 'text',
      },
    },
  });

  return normalisePackageDisplayNameResponse(response.output_text || '');
}
